<template>
	<div class="row" v-show="!loading">
		<div class="col-lg-6">

			<tank-group-form v-if="showTankGroupForm" :tank-group.sync="tankGroup" :just-repositioned.sync="justRepositioned"></tank-group-form>
			<fermenter-form v-else :fermenter.sync="fermenter" :just-repositioned.sync="justRepositioned"></fermenter-form>

		</div>
		<div class="col-lg-6">
			<div class="box">
				<div class="box-header">
					<h2 class="box-title">Fermenter List</h2>
				</div>
				<div class="box-body">

					<a @click="createNewFermenter" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> Create New Fermenter</a>
					<a @click="createNewTankGroup" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> Create New Tank Group</a>

					<hr />

					<div class="alert alert-info">
						<i class="fa fa-info-circle"></i> Drag and drop your fermenters list into your preferred correct order.
					</div>

					<ol class="sortable">
						<li v-for="tankGroup in tankGroups" :id="`tank_${tankGroup.id}`" class="tank_group" @click.stop="edit('tankGroup', tankGroup)" :class="{'active': tankGroup.id == activeTankGroup.id}">
							<div>{{ tankGroup.name }}</div>

							<ol v-if="tankGroup.fermenters">
								<li v-for="fermenter in tankGroup.fermenters.data" @click.stop="edit('fermenter', fermenter)" :class="{'active': fermenter.id == activeFermenter.id}" :id="`fermenter_${fermenter.id}`">
									<div>{{ fermenter.name }}</div>
								</li>
							</ol>
						</li>
					</ol>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { TankGroups as TankGroupActions, Fermenters as FermenterActions, App as AppActions } from 'vx/actions'
import { tankGroups, site, fermenter as activeFermenter, tankGroup as activeTankGroup, loading } from 'vx/getters'
import FermenterForm from './fermenters-form'
import TankGroupForm from './tank-groups-form'
import Notify from 'utils/notify'
import Alert from 'utils/alert'
import Vue from 'vue'

export default {
	components: {
		FermenterForm,
		TankGroupForm,
	},

	data() {
		return {
			tankGroup: {},
			fermenter: {},
			showTankGroupForm: false,
			justRepositioned: false
		}
	},

	vuex: {
		actions: {
			allTankGroups: TankGroupActions.all,
			editFermenter: FermenterActions.edit,
			clearFermenter: FermenterActions.clear,
			editTankGroup: TankGroupActions.edit,
			clearTankGroup: TankGroupActions.clear,
			reposition: TankGroupActions.reposition,
			setTitle: AppActions.title
		},

		getters: {
			tankGroups,
			site,
			activeTankGroup,
			activeFermenter,
			loading
		}
	},

	watch: {
		activeTankGroup() {
			this.tankGroup = $.extend({}, this.activeTankGroup);
		},
		activeFermenter(newActiveFermenter) {
			this.fermenter = $.extend({}, this.activeFermenter);
		}
	},

	route: {
		activate() {
			this.$dispatch('loading');
		},

		data() {
			this.clearFermenter();

			this.allTankGroups(this.site.id, ['fermenters.ferments']).then(response => {
				this.$dispatch('loaded');
			});
		}
	},

	ready() {
		this.setTitle('Fermenter Setup');

		$('.sortable').nestedSortable({
			handle: 'div',
			items: 'li',
			isTree: true,
			maxLevels: 2,
			toleranceElement: '> div',
			protectRoot: true,
			relocate: event => {
				let hierarchy = $('.sortable').nestedSortable('toHierarchy', { startDepthCount: 0 });

				hierarchy.forEach(parent => {
					delete parent['nestedSortable-item'];

					if (parent.children){
						parent.children.forEach(child => {
							delete child['nestedSortable-item'];
						});
					}
				});

				this.justRepositioned = true;

				this.reposition(this.site.id, hierarchy, ['fermenters']).then(response => {
					Notify.success('Fermenters have been sorted.', { timeout: 2000 });

					if (this.fermenter || this.tankGroup) {
						response.body.data.forEach(tankGroup => {
							// If we have a fermenter selected then we want to make sure that after
							// repositioning the tank groups and fermenters that we updated the
							// tank group ID of the selected fermenter. To do this we will
							// simply spin through all the tank groups and all the
							// fermenters until we find the fermenter we have
							// selected. Then we can update the selected
							// fermenters tank group ID.
							if (this.fermenter) {
								tankGroup.fermenters.data.forEach(fermenter => {
									if (fermenter.id == this.fermenter.id) {
										this.fermenter.tank_group_id = tankGroup.id;
									}
								});
							}

							// If we have an active tank group, we need to make sure we clean
							// up any of its fermenters in case they move fermenters out of a
							// tank group to perform a delete while the tank group is set as
							// the active tank group.
							if (this.tankGroup) {
								if (tankGroup.id == this.tankGroup.id) {
									this.tankGroup.fermenters = tankGroup.fermenters;
								}
							}
						});
					}
				});
			}
		});
	},

	methods: {
		edit(type, object) {
			switch (type) {
				case 'tankGroup':
					this.showTankGroupForm = true;
					this.clearFermenter();
					this.editTankGroup(object);
				break;
				case 'fermenter':
					this.showTankGroupForm = false;
					this.editFermenter(object);
					this.clearTankGroup();

					// On the next "tick" we'll show the tank group form, the
					// reason for this is because we need the changes to the
					// watched active fermenter above to take effect so
					// that the rebinding of the Select2 does not
					// get all messed up.
					Vue.nextTick(() => {
						$("#tank_group_id").trigger('change');
					});
				break;
			}
		},

		createNewFermenter() {
			this.clear();

			this.showTankGroupForm = false;

			this.$broadcast('resetValidation');
		},

		createNewTankGroup() {
			this.clear();

			this.showTankGroupForm = true;

			this.$broadcast('resetValidation');
		},

		clear() {
			this.clearTankGroup();
			this.clearFermenter();
		}
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?39a75f7d